import { GridChartView } from 'utils/components/ViewToggleButtons/ViewToggleButtons';
import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';

export interface LiquiditySummaryConfiguration
    extends WidgetConfigWithHideableToolbar {
    view: GridChartView;
    hideGridOrderLeavesLegend: boolean;
    hideChartOrderLeavesLegend: boolean;
    hideChartRodLegend: boolean;
    hideChartAcvLegend: boolean;
    hideChartHistVolLegend: boolean; // Hist Vol till now
    hideChartTodaysVolLegend: boolean; // Act Vol till now
    hideChartAuctionVolLegend: boolean; // Hist Cls Auction
    hideChartTodaysAdjLegend: boolean; // Act Adj
    hideChartExpAdjLegend: boolean; // Exp Adj
    hideChartHistVolRodLegend: boolean; // Hist Vol ROD
    hideChartTodaysVolRodLegend: boolean; // Act Vol ROD
    hideChartAuctionOpenVolLegend: boolean; // Historical open auction
    hideChartPredAuctionVolLegend: boolean; // Todays predicted closing auction
}

export const initialLiquiditySummaryConfiguration: LiquiditySummaryConfiguration =
    {
        view: 'grid',
        hideToolbar: false,
        hideGridOrderLeavesLegend: false,
        hideChartOrderLeavesLegend: false,
        hideChartRodLegend: false,
        hideChartAcvLegend: false,
        hideChartHistVolLegend: false,
        hideChartTodaysVolLegend: false,
        hideChartAuctionVolLegend: false,
        hideChartTodaysAdjLegend: false,
        hideChartExpAdjLegend: false,
        hideChartHistVolRodLegend: false,
        hideChartTodaysVolRodLegend: false,
        hideChartAuctionOpenVolLegend: false,
        hideChartPredAuctionVolLegend: false,
    };
